// extracted by mini-css-extract-plugin
export default {"ExpandedToggleContainer":"ExpandedToggle_ExpandedToggleContainer__6A5Ag","IsExpanded":"ExpandedToggle_IsExpanded__2PQ7h","UpAndDownIcon":"ExpandedToggle_UpAndDownIcon__88aKl"};